import styled from '@emotion/styled';
import { ArrowIcon } from '@common/assets';
import { useEffect, useState } from 'react';

const Container = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  right: 50%;
  transition: all 2.2s ease-out;
  transition-delay: 2s;
`;

const HandBody = styled.div`
  background: linear-gradient(180deg, #0f1629 30%, #fff 100%);
  width: 3px;
  height: 190px;
  position: absolute;
  bottom: 93%;
  zindex: 1000;

  &:before {
    background-image: url(${ArrowIcon.src});
    background-size: 20px 20px;
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    transform: rotate(78deg);
    left: -8px;
    top: -18px;
  }
`;

export type HourHandProps = {
  angle: number;
};

export const HourHand = ({ angle }: HourHandProps) => {
  const [currentTimeAngle, setCurrentTimeAngle] = useState(angle < 270 ? -260 : 270);

  useEffect(() => {
    setTimeout(() => {
      setCurrentTimeAngle(angle);
    }, 100);
  }, [angle]);

  return (
    <Container style={{ transform: `rotate(${currentTimeAngle}deg)` }}>
      <HandBody />
    </Container>
  );
};
